export default __webpack_public_path__ + "static/media/reinscription.427e6e79.png";